const driverShifts = {
  filters: {
    suppliers: 'ציים',
  },

  form: {
    information: {
      shiftDetails: {
        fields: {
          suppliers: 'ציים',
        },
      },
    },
  },
  calendarTable: {
    filters: {
      suppliers: 'ציים',
    },
  },
};

export default driverShifts;
